import { Pipe } from '@angular/core';
import { isObject, isArray, isNil } from '../utils/utils';
var DefaultsPipe = (function () {
    function DefaultsPipe() {
    }
    DefaultsPipe.prototype.transform = function (input, defaults) {
        if (!isObject(defaults)) {
            return input;
        }
        if (isNil(input)) {
            return defaults;
        }
        if (isArray(input)) {
            return input.map(function (item) {
                if (isObject(item)) {
                    return Object.assign({}, defaults, item);
                }
                if (isNil(item)) {
                    return defaults;
                }
                return item;
            });
        }
        if (isObject(input)) {
            return Object.assign({}, defaults, input);
        }
        return input;
    };
    return DefaultsPipe;
}());
export { DefaultsPipe };
DefaultsPipe.decorators = [
    { type: Pipe, args: [{ name: 'defaults' },] },
];
/** @nocollapse */
DefaultsPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=defaults.pipe.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular-pipes/esm/object/defaults.pipe.js
// module id = 269
// module chunks = 103